import { bankCardModifyState } from '@/api/financeApi/walletWithhold'
import { Message } from '@qs/ui'

export default {
  data() {
    return {
      type: '', // 状态，0-停用，1-启用
      loading: false,
      params: {},
      list: [],
      msgDialogVisible: false,
      message: '', // toast提示文字
      updateLoading: false,
    }
  },
  methods: {
    // mode: bind, change
    // 点击更换银行卡/绑定银行卡按钮
    bankCardState(row, mode) {
      const formData = {
        accountId: row.accountId,
        merchantName: row.merchantName,
        licenceNo: row.licenceNo,
        mode,
      }
      this.$router.push({
        name: mode === 'change' ? 'replaceBankCard' : 'bindBankCard',
        query: {
          data: JSON.stringify(formData),
        },
      })
    },
    // 点击启用/停用按钮
    handleState(row, type) {
      if (type === 'open') {
        if (!row.bankCardNo) {
          Message({
            message: '请绑定银行卡后开启',
            type: 'error',
            duration: 5 * 1000,
          })
          return
        }
        // 启用
        this.type = 1
        this.message = '启用成功'
      } else {
        // 停用
        this.type = 0
        this.message = '停用成功'
      }
      this.updateState(row)
    },
    // 更新状态接口
    async updateState(row) {
      if (!row.accountId) {
        Message({
          message: 'accountId为空！',
          type: 'error',
          duration: 5 * 1000,
        })
        return
      }
      try {
        const { code } = await bankCardModifyState({
          accountId: row.accountId,
          state: this.type,
        })
        if (code === 1) {
          Message({
            message: this.message,
            type: 'success',
            duration: 5 * 1000,
          })
          this.refreshTable()
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
